import i18n, { setAppLocale, getSavedLocale } from '@/i18n/index.js'

/** 轻量 t()：支持 t('search') 或 t('common.search') */
export function t(key, params = {}) {
  const path = key.includes('.') ? key : `common.${key}`
  return i18n.global.t(path, params)
}

export { setAppLocale, getSavedLocale }
